import React, { useContext, useLayoutEffect, useEffect, useState } from "react";
import { connect } from "react-redux";
import Layout from "layouts/layout";
import { TabSelector } from "components/global/tabselector";
import { TabPanel, useTabs } from "react-headless-tabs";
import LineVerticalSVG from "assets/svg/line-vertical";
import { gsap } from "gsap";
import ProfileListFollowing from "components/profile/following/following";
import VerifyIconSVG from "assets/svg/verified-icon";
import BackArrowFollowingIconSVG from "assets/svg/back-arrow-following-icon";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Context } from "context/context";
import _ from "lodash";
import { urlSerializer, currentLang } from "utils/utils";
import PopInfo from "components/info-popup/pop-info";
import ArrowLeftIcon from "assets/svg/arrow-left-icon";
import ProfileDetails from "components/profile/profile-details";
import { useTranslation } from "react-i18next";

const Following = ({ userData }) => {
  let { username, profileId } = useParams();
  const location = useLocation();
  const profileData = location.state?.useData || {};
  const { http } = global.services;
  const [selectedTab, setSelectedTab] = useTabs(["followers","following"]);
  const {t} = useTranslation()
  const { profile: data, user } = userData;
  const { following, setFollowing, followers, setFollowers } =
    useContext(Context);
  const history = useHistory();
  const [profile, setProfile] = useState(profileData);
  const [translate,setTranslate] = useState(profileData?.translation || null);
  const lang = currentLang();
  const getFollowing = async (type = "following") => {
    try {
      const { data } = await http.get("public/user-followers", {
        user_profile_id: profileId,
        type: type,
      });
      if (type === "following") {
        setFollowing(data?.data);
      } else if (type === "followers") {
        setFollowers(data?.data);
      }
    } catch (err) {
      console.log("error@getFollowing", err);
    }
  };

  const onFollow = async (id) => {
    try {
      const url = urlSerializer("/follow", {
        followed_id: id,
        follower_id: userData?.profile?.id,
      });
      const { data } = await http.post(url);
      const { follow } = data;
      if (follow) {
        getFollowing("following");
        getFollowing("followers");
      }
      return follow;
    } catch (err) {
      console.log("error@onFollow", err);
    }
  };

  useLayoutEffect(() => {
    gsap.fromTo(
      ".following-tabs",
      { scale: 0.8, opacity: 0 },
      { scale: 1, opacity: 1 }
    );
    gsap.fromTo(
      ".following-title",
      { y: -25, opacity: 0 },
      { y: 0, opacity: 1 }
    );
  }, []);

  useEffect(() => {
    if (!_.isEmpty(profileId)) {
      // if (_.isEmpty(following) || _.isEmpty(followers)) {
      getFollowing("following");
      getFollowing("followers");
      getUserProfile();
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileId]);

  const getUserProfile = async (uname) => {
    try {
      const url = urlSerializer("public/user-profiles/get-profile", {
        username: uname,
        id: profileId,
      });
      const { data } = await http.get(url);
      setProfile(data);
      setTranslate(data?.translation || null);
    } catch (err) {
      if (
        err.status === 401 &&
        err?.data?.message === "Unauthorize for adult content" &&
        userData == null
      ) {
        // setShowNoProfileFound(true);
      }

      console.log("::error@getUserProfile", err);
      console.log("error@getUserProfile", err);
    }
  };

  const notFullName = (profile_name, user) => {
    const fullName = `${user?.first_name} ${user?.last_name}`;

    const contains = !!profile_name?.toLowerCase()
      .includes?.(fullName.toLowerCase());

    const contains2 = !!fullName
      .toLowerCase()
      .includes?.(profile_name?.toLowerCase());
    if (profile_name?.toLowerCase() !== fullName.toLowerCase()) {
      if (contains || contains2) {
        return false;
      }

      return true;
    } else {
      return false;
    }
  };

  const onProfileClick = (username,profileId)=>{
    history.push(`/${username}/profile/${profileId}`);
  }


  return (
    <Layout title="Following">
      <div className="auth-page-wrapper pb-8.5">
        <div className="w-full container-max-width bg-white rounded-md px-6 pt-6.6">
          <div className="w-full flex items-center gap-4">
            <button
              // style={{ width: "46px", height: "71px" }}
              onClick={() => history.goBack()}
            >
              {/* <BackArrowFollowingIconSVG /> */}
              <ArrowLeftIcon className="font-bold text-5xl" />
            </button>
            <div className="w-full">
              <div className="w-full flex flex-row gap-x-2 items-center">
                <h1 className="following-title text-base 2sm:text-2xl 3md:text-5xl text-lightBlack tracking-normal font-bold flex flex-row items-center justify-center 3md:justify-start">
                  {/* <>{display_name() || data?.user?.username}</> */}
                  <>
                    {(translate?.[lang]?.[profile?.profile_name] || profile?.profile_name) ||
                      `${(translate?.[lang]?.[profile?.user?.first_name] || profile?.user?.first_name)}
                       ${(translate?.[lang]?.[profile?.user?.last_name] || profile?.user?.last_name)}` ||
                      (translate?.[lang]?.[profile?.other_name] || profile?.other_name) ||
                      (translate?.[lang]?.[profile?.username] || profile?.username)}
                  </>
                  {profile?.id3_verified && (
                    <VerifyIconSVG className="ml-2.5" />
                  )}
                </h1>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2 ml-8">
              <h2 className="following-title text-lg text-lightBlack font-semibold text-lightBlack tracking-normal">Followers / Following</h2>
              <PopInfo containerClass="relative" type="following" />
          </div>
          <div className="flex justify-start 3md:justify-start text-lightBlack ml-8 leading-6 flex-wrap 2sm:ml-8">
            {profile?.username && (
              <p className="text-primary font-[500]">@{(translate?.[lang]?.[profile?.username] || profile?.username)}</p>
            )}
            {/* <p>{data?.other_name}</p> */}
            {!_.isEmpty(profile?.user) && (
              <>
                <>
                  {/* <span className="font-semibold pr-2">{(profile?.profile_type?.type === 'personal' || profile?.profile_type?.type === 'character') ? "aka" : "Other names:"}</span> */}
                  {/* {data?.displayName !== 'First Name Surname' ? `${user?.first_name} ${user?.last_name} ` : ''}
                  {(data?.displayName !== 'First Name Surname' && user?.email_verified_at)  ?
                    <span className="pr-2">
                    <VerifyIconSVG className="w-3 h-3 3md:w-3 3md:h-3 ml-1 3md:ml-2.5" />
                    </span>
                    :
                    <span>/</span>
                  } */}
                  {notFullName(profile?.profile_name, profile?.user) && (
                    <>
                      {Object.keys(profile).length !== 0 && (
                        <p className="text-passwordGray">&#8226;</p>
                      )}
                      <>
                        {(translate?.[lang]?.[profile?.user?.first_name] || profile?.user?.first_name)}
                        {" "}
                        {translate?.[lang]?.[profile?.user?.last_name] || profile?.user?.last_name}{" "}
                      </>

                      {profile?.id3_verified ? (
                        <span className="flex items-center pl-1">
                          <VerifyIconSVG className="w-3 h-3 3md:w-3 3md:h-3" />
                        </span>
                      ) : (
                        <span className=""></span>
                      )}
                    </>
                  )}
                  {/* {data?.username} */}
                  {Object.keys(profile).length !== 0 &&
                    !_.isEmpty(profile?.other_name) && (
                      <>
                        <p className="text-passwordGray">&#8226;</p>
                        <span><span className="font-semibold">aka </span>{translate?.[lang]?.[profile.other_name] || profile?.other_name}</span>
                      </>
                    )}
                  {/* <p>{translate?.[lang]?.[profile.other_name] || profile?.other_name}</p> */}
                  {/* {data?.other_names && 
                    <>
                    <span>/</span>
                    {
                      data?.other_names.map((p, i) => (
                        <span key={i}>
                          {p.label}
                          {i < data?.other_names.length - 1 && " / "}
                        </span>
                      ))
                    }
                    </>
                    } */}
                </>{" "}
                {/* {Object.keys(data).length !== 0 && !_.isEmpty(data?.gender) && (
                      <p className="text-passwordGray">&#8226;</p>
                    )} */}
              </>
            )}
            {
              (profile?.profile_type?.type === 'personal' || profile?.profile_type?.type === 'character') &&
              <>
                {Object.keys(profile).length !== 0 &&
                !_.isEmpty(profile?.gender) && (
                  <p className="text-passwordGray">&#8226;</p>
                )}
                {profile?.gender && <p>{translate?.[lang]?.[profile.gender] || profile?.gender}</p>}
              </>
            }
            

            {Object.keys(profile).length !== 0 &&
              !_.isEmpty(profile?.address) && (
                <p className="text-passwordGray">&#8226;</p>
              )}
            {profile?.address && <p>{translate?.[lang]?.[profile.address] ||profile?.address}</p>}
          </div>
          <div className="following-tabs flex justify-center flex-wrap 1md:flex-nowrap 1md:justify-start items-center mt-11.5">
            
            <TabSelector
              isActive={selectedTab === "followers"}
              gap="3sm:ml-7.6 3sm:mr-7.6"
              colorType="black"
              paddingY="pb-6.5"
              onClick={() => setSelectedTab("followers")}>
              <div className="w-full flex justify-center items-center">
                {/* {_.size(followers)}  */}
                Followers
              </div>
            </TabSelector>
            <div className="hidden 3sm:block -mt-[26px]">
              <LineVerticalSVG />
            </div>
            <TabSelector
              isActive={selectedTab === "following"}
              gap="3sm:mr-7.6"
              colorType="black"
              paddingY="pb-6.5"
              onClick={() => setSelectedTab("following")}
            >
              <div className="w-full flex justify-center items-center">
                {/* {_.size(following)} Connection{_.size(following) > 1 ? "s" : ""} */}
                {/* {t("mutualConnections", {//not working on arabic
                    count: _.size(following) <= 1 ? 1 : _.size(following),
                  })} */}
                {_.size(following)>1? t('following'):t('following')}
              </div>
            </TabSelector>
            
          </div>
        </div>
        <div className="w-full container-max-width">
          <TabPanel hidden={selectedTab !== "following"}>
            <ProfileListFollowing
              list={following}
              type="following"
              onFollow={(e) => onFollow(e)}
              isYourProfile={profile?.id === userData?.profile?.id}
              onProfileClick={(username,profileId) => onProfileClick(username,profileId)}
            />
          </TabPanel>
          <TabPanel hidden={selectedTab !== "followers"}>
            <ProfileListFollowing
              list={followers}
              type="follower"
              onFollow={(e) => onFollow(e)}
              isYourProfile={profile?.id === userData?.profile?.id}
              onProfileClick={(username,profileId) => onProfileClick(username,profileId)}
            />
          </TabPanel>
        </div>
      </div>
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.user.userData,
  };
};

export default connect(mapStateToProps)(Following);
